// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsCard_card__RankX","info":"NewsCard_info__11qNN","infoMore":"NewsCard_infoMore__v3RWX","image":"NewsCard_image__IXD7x","deleteIcon":"NewsCard_deleteIcon__WV4vG"};